module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.User.info) ? _c('div', [_c('div', {
    staticClass: "modal small has-text-left",
    class: {
      'is-active': _vm.modal.active
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card"
  }, [_c('section', {
    staticClass: "modal-card-body content"
  }, [_c('h3', [_vm._v("Important Notice for All Eurotraders! (Action Required)")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h3', [_vm._v("What action do you need to take?")]), _vm._v(" "), _c('h4', [_vm._v("You’ll need to choose from the following options:")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('button', {
    staticClass: "agree",
    on: {
      "click": function($event) {
        return _vm.doAgree()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small",
    class: {
      'is-left': _vm.Language == 'fa' || _vm.Language == 'ar', ' is-right': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v("\n            I consent")]), _vm._v(" "), _c('button', {
    staticClass: "decline",
    on: {
      "click": function($event) {
        return _vm.doDecline()
      }
    }
  }, [_c('span', {
    staticClass: "icon is-small",
    class: {
      'is-left': _vm.Language == 'fa' || _vm.Language == 'ar', ' is-right': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })]), _vm._v("\n            I decline")])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("As you may have spotted, Eurotrader has undergone some major changes to its branding, website, and offering. As part of these changes, Eurotrade Global Ltd ("), _c('strong', [_vm._v("Eurotrade Global")]), _vm._v(") will soon stop providing financial services to clients – but don’t worry, that doesn’t mean it’s the end of your Eurotrader journey!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("We’ve arranged for Eurotrade SA Pty Ltd ("), _c('strong', [_vm._v("Eurotrader SA")]), _vm._v(") to continue providing services to all clients like yourself who currently have accounts with Eurotrade Global Ltd.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Eurotrader SA is a Eurotrader entity regulated in South Africa by the FSCA. You can find more information about this "), _c('a', {
    attrs: {
      "href": "https://www.eurotrader.com/company/meet-eurotrader/",
      "target": "_blank"
    }
  }, [_vm._v("here")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_c('strong', [_vm._v("Consent to transferring your account and open positions to Eurotrader SA.")]), _vm._v(" In doing so, your MT4 accounts, balance, account history, any personal details previously provided by you and any open positions will be transferred to Eurotrade SA on 15 June 2021. You will also be bound by Eurotrader SA’s "), _c('strong', [_c('a', {
    attrs: {
      "href": "https://eurotrader-com.s3.eu-west-2.amazonaws.com/legal-documents/Terms%20and%20Conditions.pdf"
    }
  }, [_vm._v("Terms and Conditions")])]), _vm._v(". Furthermore, you’ll gain access to new products and services, including stock CFDs via MT5. ")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Decline to transfer and, instead, close your account and positions.")]), _vm._v(" If you choose to do so, please note you will not be able to deposit via card or be able to trade with Eurotrade Global as of 15 June 2021.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Warning")]), _vm._v(": If you don’t choose an option before 15 June 2021, "), _c('strong', [_vm._v("we will close your account and any open positions")]), _vm._v(", and you will be required to withdraw any remaining balance.")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e13c3f1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewTermsModal.vue
// module id = 756
// module chunks = 0